module.exports = __webpack_public_path__ + "media/images/emblems/Les_Cullayes-coat_of_arms-ae03f4740a97ac940818a7f3d0de2787.svg";